// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15BAK","name":"styles_name__Fpd3f","phone":"styles_phone__31BH4"};